import { useAppSelector } from 'hooks/useAppSelector';
import { getExecutorType } from 'reduxStore/reducers/ProfileSlice/selectors/getExecutorType';
import { InfoCard } from '../../../components/InfoCard';
import { sliderData, sliderSettings } from './constants';
import { StyledSlider } from './styled';

export const Slider = () => {
  const executorType = useAppSelector(getExecutorType);
  const slides = executorType ? sliderData.filter((item) => item.id !== 1) : sliderData;

  return (
    <StyledSlider {...sliderSettings}>
      {slides.map((sliderItem) => (
        <InfoCard key={sliderItem.id} infoItem={sliderItem} />
      ))}
    </StyledSlider>
  );
};
